//import { Page } from "./model/Page";
import { InputType, UIElementHint, InputValueBoolean, InputSingleValueString, InputSingleValueNumber, InputOptional, InputAction } from "../model/Element";
import { getElementWithPagekey, createMailLink, Flow } from '../FlowEngineAPI';

import { downloadPDFGeneric } from '../../pdf/PDFCreator';
import { Page } from "../model/Page";


//// ==============================================================================================================================
//export interface Flow {
//    Pages: Page[]
//}

export function setLang(code: string) {
    return;
}

export function getLang(): string {
    return "en";
}


// ==============================================================================================================================
// https://portal.ktr.com/technic/technical_application/Pages/questionnaire_product.aspx

let flow: Flow = {
    name: "mmc",
    label: "mmc-selection",
    Pages: [       
        new Page({
            id: "page1",
            name: "mmc_motor",
            label: "Motor",
            url: "www.ktrpage.com/page1",
            isSelected: false,
            elements:[
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "hersteller",
                    label: "Hersteller",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "type",
                    label: "Type",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "speed",
                    label: "Drehzahl (1/min)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "loadcase",
                    label: "Lastfall (%)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page2";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page ({
            id: "page2",
            name: "mmc_water_circuit",
            label: "Wasserkreislauf",
            url: "www.ktrpage.com/page1",
            isSelected: false,
            elements:[
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "max_temp",
                    label: "Max. Temperatur (°C)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "flowsize",
                    label: "Durchflussmenge (l/min)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "coolingwork",
                    label: "Kühlleistung (kW)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "max_pressure_loss",
                    label: "Max. Druckabfall (mbar)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "water_glycol",
                    label: "Wasser-Glykol-Gemisch (%)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page3";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page(
        {
            id:"page3",
            name: "air_circuit",
            label: "Ladeluftzyklus",
            url: "www.ktrpage.com/page3",
            isSelected: false,
            elements:[
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "temp_in",
                    label: "Eintrittstemperatur (°C)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type:InputType.ValueNumber,
                    name: "temp_out",
                    label: "Austrittstemperatur (°C)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "airflow",
                    label: "Luftmassenstrom (kg/s)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "coolingwork",
                    label: "Kühlleistung (kW)",
                    value: 0,
                    minValue:0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "max_pressure_loss",
                    label: "Max. Druckabfall (mbar)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "env_temp",
                    label: "Bezugstemperatur (°C)",
                    value: 0,
                    minValue: 0,
                    maxValue: 1000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page4";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id:"page4",
            name: "oil_cooler",
            label: "Ölkühler",
            url: "www.ktrpage.com/page4",
            isSelected: false,
            elements:
            [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "temp_in",
                    label: "Eintrittstemperatur (°C)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "vol_flow",
                    label: "Volumenstrom (l/min)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "coolingwork",
                    label: "Kühlleistung (kW)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "max_pressure_loss",
                    label: "Max. Druckabfall (mbar)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
               new InputOptional({
                type: InputType.Optional,
                name:"oil_type",
                label:"Ölsorte",
                value: 0,
                isMandatory:true,
                componentname:"",
                uiElementHint:UIElementHint.Dropdown,
                options:[
                    "Oil ISO VG 32",
                    "Oil ISO VG 46",
                    "Oil ISO VG 68",
                    "Oil ISO VG 100",
                    "Oil ISO VG 150",
                    "Oil ISO VG 220",
                    "Oil ISO VG 320",
                    "Oil ISO VG 460",
                ]
            }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page5";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page(
        {
            id:"page5",
            name: "ventilator",
            label: "Ventilator",
            url: "www.ktrpage.com/page5",
            isSelected: false,
            elements:[
                new InputOptional({
                    type: InputType.Optional,
                    name: "air_drive",
                    label: "Lüfterantrieb",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options:["direkt","hydraulisch"]
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "type",
                    label: "Bezeichnung/Typ",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "speed",
                    label: "Drehzahl (1/min)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "op_state",
                    label: "Betriebszustand",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options:["saugend","drückend"]
                }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page6";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page(
        {
            id: "page6",
            name:"qm_other_requirements",
            label:"Dokumentation und QM-Anforderungen",
            url:"www.ktrpage.com/page6",
            isSelected:false,
            elements:[
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name: "materialzeugnis",
                    label: "Materialzeugnis",
                    value: false,
                    isMandatory: false,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:"Anmerkung_Materialzeugnis",
                    label:"Anmerkung Materialzeugnis",
                    value:"",
                    isMandatory: false,
                    componentname:"",
                    uiElementHint:UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputValueBoolean | undefined = getElementWithPagekey("page6", "materialzeugnis") as InputValueBoolean;
                        if(el !== undefined) {
                            if(el.value === true)
                                return true;
                            else
                                return false;
                        } else {
                            return false;
                            //TODO: Hier eingefügt temporär
                        }
                    }
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name: "erstmusterprüfbericht",
                    label: "Erstmusterprüfbericht",
                    value: false,
                    isMandatory: false,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:"anmerkung_erstmusterpruefbericht",
                    label:"Anmerkung Erstmusterprüfbericht",
                    value:"",
                    isMandatory: false,
                    componentname:"",
                    uiElementHint:UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputValueBoolean | undefined = getElementWithPagekey("page6", "erstmusterprüfbericht") as InputValueBoolean;
                        if(el !== undefined) {
                            if(el.value === true)
                                return true;
                            else
                                return false;
                        } else {
                            return false;
                            //TODO: Hier eingefügt temporär
                        }
                    }
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name: "ATEX",
                    label: "ATEX",
                    value: false,
                    isMandatory: false,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:"Sonstiges",
                    label:"Sonstiges",
                    value:"",
                    isMandatory: false,
                    componentname:"",
                    uiElementHint:UIElementHint.Editbox
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page7";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page(
        {
            id:"page7",
            name: "temperatures",
            label: "Temperaturen",
            url: "www.ktrpage.com/page7",
            isSelected: false,
            elements:[
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "temp_air_in",
                    label: "Lufteintrittstemperatur (°C)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "temp_air_env",
                    label: "Umgebungstemperatur (°C)",
                    value: 0,
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page99";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page(
        {
            id: "page99",
            name:"Ergebnis",
            label:"Ergebnis",
            url:"www.ktrpage.com/page99",
            isSelected: false,
            showOverview: true,
            elements:[
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Firma",
                    label: "Firma",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Anschrift",
                    label: "Anschrift",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Name",
                    label: "Name",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Telefon",
                    label: "Telefon",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),

                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Bemerkkung",
                    label: "Bemerkung",
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),

                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Mail",
                    label: "Mail",
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint:UIElementHint.Editbox,
                }),
                new InputAction({
                    type: InputType.Action,
                    name:"Send Mail",
                    label:"Send Mail",
                    value:"",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Button,
                    onAction: () => {
                        let url: string = createMailLink("k.tebroke@ktr.com", "Auslegung für Verbrennungsmotoren");
                        window.location.href = url;
                        //window.open(url);
                    }
                }),
                new InputAction({
                    type: InputType.Action,
                    name:"Save PDF",
                    label:"Save PDF",
                    value:"",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Button,
                    onAction: () => {
                        downloadPDFGeneric(flow.label);
                    }
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page99";
                return nextPage;
            }
        }),

        // ---------------------------------------------------------------------------------------------------------------
    ]
    };

export { flow };
